export type CmsWorkspaceSidebarActionAppearance = 'default' | 'pricing-action';

export function resolveCmsWorkspaceSidebarHrefAppearance(
  href: string
): CmsWorkspaceSidebarActionAppearance {
  const normalizedPath = href.split('?')[0]?.split('#')[0] ?? '';

  return normalizedPath === '/pricing' || normalizedPath.endsWith('/pricing')
    ? 'pricing-action'
    : 'default';
}
